
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rivals/join",
      function () {
        return require("private-next-pages/rivals/join.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rivals/join"])
      });
    }
  